import { useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import { TApiGenericError } from "../../timenotes-query/timenotes-query.types"

interface Result {
  apiToken: string
}

export const useRegenerateApiTokenMutation = (options: any = {}) => {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const query = useMutation<Result, TApiGenericError<any>, void>(
    ['api-token', 'regenerate'],
    async () => {
      const response = await apiClient.regenerateApiToken()

      if (!response.ok) {
        throw response.errors || {}
      }

      return { apiToken: response.apiToken }
    },
    {
      ...options,
      onSuccess: (data, variables, ctx) => {
        queryClient.invalidateQueries(['current-user'])
        if (options.onSuccess) options.onSuccess(data, variables, ctx)
      },
    },
  )

  return query
}
